import React from "react";
import _ from "lodash";
import { connect } from "react-redux";

import { setUser, setUserActivities } from "../actions";

import {
    cleanUpAuthToken,
    testAuthGetter,
    getUserData,
    getUserActivities,
} from "../utils/functions";

class StravaRedirect extends React.Component {
    componentDidMount() {
        const authenticate = async () => {
            const { history, location } = this.props;
            try {
                // If not redirected to Strava, return to home
                if (_.isEmpty(location)) {
                    return history.push("/");
                }

                // Save the Auth Token to the Store (it's located under 'search' for some reason)
                const stravaAuthToken = cleanUpAuthToken(location.search);

                // Post Request to Strava (with AuthToken) which returns Refresh Token and and Access Token
                const tokens = await testAuthGetter(stravaAuthToken);
                
                if (!tokens) {
                    throw new Error("Failed to get tokens from Strava");
                }
                
                this.props.setUser(tokens);
                const accessToken = tokens.access_token;
                const userID = tokens.athlete.id;

                // Axios request to get users info
                const user = await getUserData(userID, accessToken);
                const activities = await getUserActivities(accessToken);
                this.props.setUserActivities(activities || null);

                // Once complete, navigate parent window to list page and close popup
                if (window.opener) {
                    window.opener.top.location.href = "https://trailmaps.com/products/design-your-own-trail-map/list";
                    window.close();
                } else {
                    history.push("/list");
                }
            } catch (error) {
              console.log("StravaRedirect: Authentication failed:", error);
              console.log("StravaRedirect: Location search:", location.search);
              console.log("StravaRedirect: Full location:", location);
                if (window.opener) {
                    window.opener.postMessage({
                        type: "STRAVA_AUTH_FAILURE",
                        error: error.message,
                        location: location.search
                    }, 'https://trailmaps.com');
                    console.log("StravaRedirect: Failure message sent, closing popup");
                    window.close();
                } else {
                    console.log("StravaRedirect: No opener found, navigating to /");
                    history.push("/");
                }
            }
        };
        authenticate();
    }

    render() {
        return <div>Loading</div>;
    }
}

const mapStateToProps = (state) => {
  return { authTokenURL: state.authTokenURL };
};

export default connect(mapStateToProps, {
  setUserActivities,
  setUser,
})(StravaRedirect);